export const CareersUrl =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://careers.entnt.in"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://testentntcareers-c8hbbyh2bwcvawev.centralindia-01.azurewebsites.net"
      : "http://localhost:3001";

export const AssessmentUrl =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://assessments.entnt.in"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://test.assessments.entnt.in"
      : "http://localhost:3002";

export const RecruitmentUrl =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://recruitment.entnt.in"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://test.recruitment.entnt.in/"
      : "http://localhost:3000";
